<template>
    <div class="order_pos__status_item" :style="styleError" @click.prevent="clickLogItem">
        <div class="order_pos__status_item_sign" :class="imgClass">
            <img :src="'/icons/'+this.status_order+'.svg'">
        </div>
        <div class="order_pos__status_item_info">
            <div class="order_pos__status_item_info_block">
                <div class="order_pos__status_item_info_block_time">
                    {{ timeOrder }}
                </div>
                <div class="order_pos__status_item_info_block_state">
                    {{ stateOrder }}
                </div>
            </div>
            <div v-if="isInfo" class="order_pos__status_item_info_text">
                {{ infoOrder }}
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "order_pos_item",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    emits: [],
    components: {},
    mixins: [],
    data() {
        return {
            showLogFull: false,
        }
    },
    methods: {
        getDataCourier() {
            let dataCourier = null;
            let regTemplate = 'courier';
            let regex = new RegExp(regTemplate, 'gi');
            if (this.item.action_type && regex.test(this.item.action_type)) {
                if (this.item.action_data && this.item.action_data.data)
                    dataCourier = this.item.action_data.data;
            }
            regTemplate = 'couirer';
            regex = new RegExp(regTemplate, 'gi');
            if (this.item.action_type && regex.test(this.item.action_type)) {
                if (this.item.action_data && this.item.action_data.data)
                    dataCourier = this.item.action_data.data;
            }

            return dataCourier;
        },
        clickLogItem() {
            if (this.isError) {
                let logInfo = {};
                if (this.item.action_data) {
                    logInfo.action_data = this.item.action_data;
                }
                if (this.item.payload) {
                    logInfo.payload = this.item.payload;
                }
                EventBus.$emit('show_modal_left', logInfo);
            }
        },
    },
    computed: {
        status_order() {
            // if (this.item.action_type) {
            //     let regTemplate = 'accept';
            //     let regex = new RegExp(regTemplate, 'gi');
            //     if (regex.test(this.item.action_type)) {
            //         return 'status_accept';
            //     }
            //     regTemplate = 'ready';
            //     regex = new RegExp(regTemplate, 'gi');
            //     if (regex.test(this.item.action_type)) {
            //         return 'status_ready';
            //     }
            // }
            if (this.isError) {
                return 'status_process';
            }
            return 'status_ready';
        },
        timeOrder() {
            if (this.item.added) {
                let dateOrder = new Date(this.item.added);
                let hours = dateOrder.getHours();
                let minutes = dateOrder.getMinutes();
                let seconds = dateOrder.getSeconds();
                if (hours < 10) {
                    hours = '0' + hours;
                }
                if (minutes < 10) {
                    minutes = '0' + minutes;
                }
                if (seconds < 10) {
                    seconds = '0' + seconds;
                }
                return hours + ':' + minutes + ':' + seconds;
            }

        },
        stateOrder() {
            if (this.item.action_type) {
                return this.item.action_type;
            }
            return '';
        },
        infoOrder() {
            const data = this.getDataCourier();
            if (data !== null && data.partial_name && data.phone) {
                return data.partial_name + ', ' + data.phone
            }
            return '';
        },
        isInfo() {
            return this.infoOrder !== '';
        },
        isError() {
            return this.item.status && this.item.status === "operation_fail";
        },
        styleError() {
            if (this.isError) {
                return 'cursor: pointer;'
            }
            return '';
        },
        logFullString() {
            return JSON.stringify(this.item, null, 2).trim();
        },
        imgClass(){
            if(this.isInfo){
                return {'info': true};
            }
            return '';
        }
    },
}
</script>
